import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="modern-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src='/adgro-logo-color.png' alt='adgro' className="footer-logo-img" />
            </div>
            <p className="footer-description">
              {t('footer-links.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>{t('footer-links.quick-links')}</h4>
            <ul>
              <li><Link to="/">{t('header.nav.home')}</Link></li>
              <li><a href="/#why-choose-us">{t('header.nav.features')}</a></li>
              <li><a href="/#pricing">{t('header.nav.pricing')}</a></li>
              <li><a href="/#signup-form">{t('header.nav.contact')}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-links">
            <h4>{t('footer-links.legal')}</h4>
            <ul>
              <li><Link to="/terms">{t('footer.terms')}</Link></li>
              <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
